// extracted by mini-css-extract-plugin
export default {"AnchorLink":"Nav_AnchorLink__nsWnb"};